module.exports = __webpack_public_path__ + "img/win-s2-2.5f606c71.png";